module.exports = __webpack_public_path__ + "static/img/user2_2.6e9dafa3.png";